import script from "./TongHopVatTuTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TongHopVatTuTable.vue?vue&type=script&lang=ts&setup=true"

import "./TongHopVatTuTable.vue?vue&type=style&index=0&id=3acefe1a&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acefe1a"]])

export default __exports__